import * as types from '../actions/actionTypes';

const initialState = {
    details: {
        loading: false,
        success: true,
        data: {}
    },
    updateCampaignList: {
        loading: false,
        success: true
    },
    allParticipants: {
        loading: false,
        success: true,
        data: []
    },
    newParticipant: {
        loading: false,
        success: true,
        message: ''
    },
    pendingParticipants: {
        loading: false,
        success: true,
        data: []
    }
}

export default (state = initialState, action) => {
    switch (action.type) {
        case types.START_GET_CAMPAIGN_LIST_DETAILS:
            return Object.assign({}, state, { details: { ...initialState.details, loading: true } });
        case types.GET_CAMPAIGN_LIST_DETAILS:
            return Object.assign({}, state, { details: action.response });
        case types.CLEAR_CAMPAIGN_LIST_DETAILS:
            return Object.assign({}, state, { details: initialState.details });

        case types.START_UPDATE_CAMPAIGN_LIST_DETAILS:
            return Object.assign({}, state, { updateCampaignList: { ...initialState.updateCampaignList, loading: true } });
        case types.UPDATE_CAMPAIGN_LIST_DETAILS:
            return Object.assign({}, state, {
                updateCampaignList: { loading: false, success: action.response.success },
                details: { ...state.details, data: action.response.success ? action.response.data : state.details.data }
            });

        case types.START_GET_CAMPAIGN_LIST_ALL_PARTICIPANTS:
            return Object.assign({}, state, { allParticipants: { ...initialState.allParticipants, loading: true } });
        case types.GET_CAMPAIGN_LIST_ALL_PARTICIPANTS:
            return Object.assign({}, state, { allParticipants: action.response });

        case types.START_ADD_CAMPAIGN_LIST_PARTICIPANT:
            return Object.assign({}, state, { newParticipant: { ...initialState.newParticipant, loading: true } });
        case types.ADD_CAMPAIGN_LIST_PARTICIPANT:
            return Object.assign({}, state, { newParticipant: { success: action.response.success, loading: action.response.loading, message: action.response.message } });

        case types.START_GET_CAMPAIGN_LIST_PENDING_PARTICIPANTS:
            return Object.assign({}, state, { pendingParticipants: { ...initialState.pendingParticipants, loading: true } });
        case types.GET_CAMPAIGN_LIST_PENDING_PARTICIPANTS:
            return Object.assign({}, state, { pendingParticipants: action.response });

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/CampaignListDetailsReducer.js